// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M7.11 3.991A1.5 1.5 0 1 0 4.89 6.01l4.598 5.056-4.584 4.911a1.5 1.5 0 0 0 .57 2.429l6.805 2.551-1.75 8.75a1.5 1.5 0 0 0 2.567 1.318l7.363-7.889 4.431 4.875a1.5 1.5 0 0 0 2.22-2.018l-20-22Zm7.396 21.125.965-4.822a1.5 1.5 0 0 0-.945-1.699l-5.901-2.211 2.884-3.091 6.922 7.614-3.925 4.21Zm-.58-16.608a1.5 1.5 0 0 1-.074-2.125L18.904.976a1.5 1.5 0 0 1 2.567 1.318l-1.75 8.75 6.805 2.551a1.499 1.499 0 0 1 .57 2.429l-2.102 2.25a1.5 1.5 0 0 1-2.194-2.047l.572-.613-5.898-2.212a1.5 1.5 0 0 1-.945-1.698l.971-4.82-1.454 1.551a1.5 1.5 0 0 1-2.12.072Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
